import React, { useEffect, useState } from "react";
import AppsContainer from "../../../@crema/core/AppsContainer";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import AppsHeader from "../../../@crema/core/AppsContainer/AppsHeader";
import AppsContent from "../../../@crema/core/AppsContainer/AppsContent";
import AppsPagination from "../../../@crema/core/AppsPagination";
import AppInfoView from "../../../@crema/core/AppInfoView";
import { Input, Button, Modal, Typography } from "antd";
import "./index.style.less";
import AppPageMetadata from "../../../@crema/core/AppPageMetadata";
import { usePermissions } from "lib/permissionHook";
import {
  getTaxManagements,
  setPage,
  setSearch,
} from "redux/actions/TaxManagement";

import TaxManagementTable from "./TaxManagementTable";
import AddTaxManagement from "./AddTaxManagement";
import ModalCloseConfirm from "lib/components/ModalCloseConfirm";
import { AppLoader } from "@crema";

import AwesomeDebouncePromise from "awesome-debounce-promise";

const debounceSearchOrder = AwesomeDebouncePromise(
  (search, dispatch) => {
    dispatch(setSearch(search));
    dispatch(setPage(1));
  },
  500,
  {
    onlyResolvesLast: true,
  }
);

const MODULE_NAME = "TAX MANAGEMENT";

function TaxManagement() {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const { taxManagement, taxManagementCount, page, search } = useSelector(
    ({ taxManagement }) => taxManagement
  );
  const { loading } = useSelector(({ common }) => common);
  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { profile } = useSelector(({ profile }) => profile);

  const permission = usePermissions(MODULE_NAME, profile);

  const onChange = (page) => {
    dispatch(setPage(page));
  };

  useEffect(() => {
    dispatch(getTaxManagements());
  }, [dispatch, search, page]);

  const onSearchOrder = (e) => {
    debounceSearchOrder(e.target.value, dispatch);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    return () => {
      dispatch(setPage(1));
      dispatch(setSearch(""));
    };
  }, []);

  return (
    <>
      <AppPageMetadata title="Tax Management" />
      <AppsContainer
        title={messages["sidebar.admin.tax-management"]}
        fullView
        type="bottom"
      >
        <AppsHeader key={"wrap"}>
          <div className="customer-header">
            <div className="customer-header-input-view">
              <Input
                id="user-name"
                placeholder="Search"
                type="search"
                onChange={onSearchOrder}
              />
            </div>
            <Typography style={{ padding: "0 0.5rem" }}>
              Total: {taxManagementCount}
            </Typography>
            <div className="customer-header-right">
              <Button
                type="primary"
                onClick={showModal}
                disabled={
                  permission && !permission.create && !profile.isSuperAdmin
                }
              >
                Add Tax Management
              </Button>

              <AppsPagination
                className="customer-header-pagination"
                pageSize={10}
                current={page}
                count={taxManagementCount}
                page={page}
                onChange={onChange}
              />
            </div>
          </div>
        </AppsHeader>

        <AppsContent
          key={"wrap1"}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          <TaxManagementTable loading={loading} taxManagement={taxManagement} />
        </AppsContent>

        <AppsPagination
          key={"wrap2"}
          className="customer-footer-pagination"
          pageSize={10}
          current={page}
          count={taxManagementCount}
          page={page}
          onChange={onChange}
        />
      </AppsContainer>

      <Modal
        title={messages["admin.addTaxManagement"]}
        visible={isModalVisible}
        onOk={handleOk}
        footer={false}
        width={800}
        maskClosable={false}
        destroyOnClose={true}
        closeIcon={<ModalCloseConfirm onCancel={handleCancel} />}
      >
        <AddTaxManagement closeModel={handleCancel} />
      </Modal>

      <AppInfoView />
      {loader ? <AppLoader /> : null}
    </>
  );
}

export default TaxManagement;
